var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("  = "+_vm._s(`${_vm.formatTime(this.numberOfSeconds).hour} hours, ${ _vm.formatTime(this.numberOfSeconds).minute } minutes, ${_vm.formatTime(this.numberOfSeconds).second} seconds`))])
}
var staticRenderFns = []

export { render, staticRenderFns }